import strings from '../../resources/strings';

const { pdfContent } = strings.addFiles;
const consts = {
    formats: {
        pdf: 'application/pdf',
        image: 'image/*',
    },
    inputContent: {
        pdf: pdfContent,
    },
    path: {
        pdf: 'Attachments',
    },
    rewordTypeList: [
        {
            name: { en: 'Badge' },
            id: '1',
        },
        {
            name: { en: 'Proficiency' },
            id: '2',
        },
    ],
};

export default consts;
